module.exports = __webpack_public_path__ + "static/Base_Logos_clientes_Riclan-71a90da677ca40a08904eba7763d173d.png";